"use client";

import React, { RefObject, useRef } from "react";

/**
 * Use this component if your tile needs to ref to container's css props.
 * e.g. absolute position for components overlays on image.
 */
export const ProductTileContainerRefContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  return (
    <ProductTileContainerRefContext.Provider value={containerRef}>
      {children}
    </ProductTileContainerRefContext.Provider>
  );
};

export const useProductTileContainerRef = () => {
  return React.useContext(ProductTileContainerRefContext);
};

const ProductTileContainerRefContext =
  React.createContext<RefObject<HTMLDivElement | null> | null>(null);
